import NewReceipt from '../../pages/Receipt/NewReceipt';
import React, { useState } from 'react';
import * as yup from 'yup';
import { phoneRegExp } from '../../utils/utils';

const NewReceiptContainer = ({ closeModal }) => {
	const [stage2, setStage2] = useState(false);
	const [anotherService, setAnotherService] = useState([
		{ service: '', price: '', quantity: '', amount: '' },
	]);

	const [plusService, setPlusService] = useState(false);

	const receiptDetailsValidation = () => {
		return yup.object({
			customerName: yup.string().required('Customer name is required'),
			customerPhone: yup
				.string()
				.matches(phoneRegExp, 'Phone number is not valid')
				.required('Customer phone number is required'),
		});
	};

	const goToStage2 = () => {
		setStage2(true);
	};

	const addAnotherService = () => {
		let newService = { service: '', price: '', quantity: '' };

		setAnotherService([...anotherService, newService]);

		if (anotherService.length > 1) {
			setPlusService(true);
		}
	};

	const removeService = () => {
		let services = [...anotherService];
		services.splice(-1);
		setAnotherService(services);

		if (anotherService.length === 1) {
			setPlusService(false);
		}
	};

	return (
		<NewReceipt
			closeModal={closeModal}
			stage2={stage2}
			goToStage2={goToStage2}
			receiptDetailsValidation={receiptDetailsValidation}
			anotherService={anotherService}
			addAnotherService={addAnotherService}
			plusService={plusService}
			removeService={removeService}
		/>
	);
};

export default NewReceiptContainer;
